/**
 * @prettier
 */
export function createServerGitHubBranchUrl(branchName?: string): string {
    return `https://github.com/pidedirecto/pidedirectoserver/tree/${branchName ?? ''}`;
}
